import Toast from "components/toast";
import { _goToBack } from "routers/helper";

export const onAddCategoryRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  _goToBack();
};

export const onEditCategoryRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  _goToBack();
};

export const onDeleteCategoryRes = onEditCategoryRes;
